import ROUTER from '../graphql/Route.graphql';


/**
 * @var client graphql
 * @param fetchPolicy
 * @param variables
 */
export const getRoute = ({ fetchPolicy, variables }: any = {}) => (client: any) => {
  variables = variables || { path: '/' };
  return client.query({
    query: ROUTER,
    variables,
    fetchPolicy: fetchPolicy || 'cache-first'
  })
}

export default getRoute;